import axiosInstance from "./axiosInstance.ts";
import logger from "../utils/logger.ts";

export const getAllSettings = async () => {
    try {
        // console.log("🔍 Fetching settings from API...");
        // console.log("🌐 API URL:", axiosInstance.defaults.baseURL);
        // console.log("🔑 Headers:", axiosInstance.defaults.headers);
        
        const response = await axiosInstance.get('/settings/all');
        console.log("✅ Settings API response:", response);
        return response;
    } catch(error: any) {
        console.error("❌ Settings API error details:", {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data,
            config: {
                url: error.config?.url,
                method: error.config?.method,
                headers: error.config?.headers
            }
        });
        logger.error("Error has occurred attempting to fetch the settings. Please try again or contact administration.");
        throw error;
    }
}

export const settingsApi = {
    getAllSettings,
    
    getProfessions: async () => {
        try {
            const response = await axiosInstance.get('/settings/professions');
            return response.data;
        } catch (error: any) {
            logger.error("Error fetching professions:", error);
            throw error;
        }
    },
    
    createProfession: async (data: { professionName: string; professionKey?: string; colorHex?: string | null }) => {
        try {
            const response = await axiosInstance.post('/settings/professions', data);
            return response.data;
        } catch (error: any) {
            logger.error("Error creating profession:", error);
            throw error;
        }
    },
    
    updateProfession: async (id: number, data: { professionName?: string; professionKey?: string; colorHex?: string | null }) => {
        try {
            const response = await axiosInstance.put(`/settings/professions/${id}`, data);
            return response.data;
        } catch (error: any) {
            logger.error("Error updating profession:", error);
            throw error;
        }
    },
    
    deleteProfession: async (id: number) => {
        try {
            const response = await axiosInstance.delete(`/settings/professions/${id}`);
            return response.data;
        } catch (error: any) {
            logger.error("Error deleting profession:", error);
            throw error;
        }
    },
};
